import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import MinibioHome from "@/pages/MinibioHome";

const BioPublicPage = lazy(() => import("@/pages/BioPublicPage"));

/* App-Hülle für die Zweit-Domain minibio.info – nur Mini-Websites, KEIN DIMEDIAL-Header/Footer.
   /<handle> und /@<handle> zeigen die Mini-Website; alles andere die neutrale Startseite. */
export default function MinibioApp() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[#0F0F14]" />}>
      <Routes>
        <Route path="/" element={<MinibioHome />} />
        <Route path="/@:handle" element={<BioPublicPage minibio neutralFallback={<MinibioHome />} />} />
        <Route path="/:handle" element={<BioPublicPage minibio neutralFallback={<MinibioHome />} />} />
        <Route path="*" element={<MinibioHome />} />
      </Routes>
    </Suspense>
  );
}
